import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { AppUtils } from '../../utlis/app-utils';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { NavigationEnd, Router } from '@angular/router';
import { NotificationTitleComponent } from '../notification-title/notification-title.component';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomConfirmationDialogComponent } from '../../custom-confirmation-dialog/custom-confirmation-dialog.component';

@Component({
  selector: 'dl-qn-sbn-side-navigation',
  standalone: true,
  imports:[OneWebComponentsAngularModule,NgClass,FormsModule,CustomConfirmationDialogComponent],
  templateUrl: './qn-sbn-side-navigation.component.html',
  styleUrl: './qn-sbn-side-navigation.component.scss',
  providers: [AppUtils],
})
export class QnSbnSideNavigationComponent {

  @Input() public viewMode: string;
  @Output() public updateBtnState = new EventEmitter<{ isPrevState: boolean; isNextState: boolean }>();
  public storedData: any;
  public currentRoute: string;
   public isNotiDoc: boolean = true;
  public isRecepient: boolean = true;
  public isMess_Att: boolean = true;
  public isDue_Rem: boolean = true;
  public contactLimitNumber: number = 5000;
  public DueDateEnabled: boolean = true;
  public nonSavedFeedback: boolean = false;
  public isValid: boolean = false;
  public fbDisabledAndEnabled: boolean = false;
  public feedbackAdded: boolean = false;
  public isDailyReport: boolean = true;
   public isEnableDailyReport: boolean;
  public feedbackEdited: boolean = false;
   public DocumentEnabled: boolean = true;
  public visible: boolean = false;
  public confirmationDialogVisible: boolean = false;
  public inputData: any;
  
  // Define the routes in order
  private readonly routes = [
    '/create-notification/notification-title',
    '/create-notification/notification-doc',
    '/create-notification/recipients',
    '/create-notification/message-attachment',
    '/create-notification/configure-feedback',
    '/create-notification/due-date-reminder',
    '/create-notification/daily-summary-report'
  ];

  public constructor(
    public _QnSbnService:QnSbnService,
    public _QnSbnDataService:QnSbnDataServiceService,
    private _AppUtils:AppUtils,
    private changeDetectorRef: ChangeDetectorRef,
    private router:Router

  ){}

   public isActive(url: string): boolean {
    return this.currentRoute === url;
  }

 ngOnInit(): void {
     this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      this.currentRoute = event.urlAfterRedirects;
      setTimeout(() => {
        this.asterixValidation();
        this.changeDetectorRef.detectChanges();
      }, 100);
    }
  });
    this._QnSbnDataService.mappingData$.subscribe(storeData=>{
      this.storedData = storeData;
    })

    this._QnSbnDataService.DueDateEnabled$.subscribe(
      res =>{
        this.DueDateEnabled = res;
       
      } 
    )
    this._QnSbnDataService.DailyReportEnabled$.subscribe(
      res =>{
        this.isEnableDailyReport = res;
      }
    )
    this._QnSbnDataService.DocumentEnabled$.subscribe(
      res =>{
        this.DocumentEnabled = res;
        this.asterixValidation();
      } 
    )
  }

  isValidDate(dateObject){
    return new Date(dateObject).toString() !== 'Invalid Date';
  }

  public findDuplicates(arr) {
    return arr.filter((target, index) => {
      return (
        arr.some((obj, targetIndex) => 
        index !== targetIndex && 
        obj.customerId === target.customerId &&
        obj.customerEmail === target.customerEmail)
      )
      || (
        arr.some((obj, targetIndex)  => 
        index !== targetIndex && 
        obj.customerId === target.customerId && 
        obj.customerName !== target.customerName)
      ) ;
    });
  }

  public findEmpties(arr: any[]): any[] {
  return arr.filter((i) => {
    return (
      !i.customerContactName ||
      !i.customerEmail ||
      !i.customerId ||
      !i.customerName ||
      !i.sourceName
    );
  });
}


   public updatePrevNextBtnState(isPrev: boolean, isNext: boolean, menu: string, route: string): void {

    this.nonSavedFeedback = this._QnSbnDataService.isAfoBtnDisabled$.value;
    this.isValid = this._QnSbnDataService.isValidFeedback$.value;
    this.fbDisabledAndEnabled = this._QnSbnDataService.fbDisabledAndEnabled$.value;
    this.feedbackAdded = this._QnSbnDataService.isFeedbackAdded$.value;
    this.feedbackEdited = this._QnSbnDataService.isEdited$.value;
    if((this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) || 
      (this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && this.feedbackAdded) ||
      (!this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) ||
      (!this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && this.feedbackAdded && this.feedbackEdited) ||
      (!this.nonSavedFeedback && this.isValid && this.fbDisabledAndEnabled )){
      
      this.inputData = {
        title: 'Warning',
        message: 'You have changes not applied in the feedback form controls. Please apply them to continue.',
        confirmButtonText: 'Accept'
      };
      
      this.visible = true;
      this._QnSbnDataService.isAfoBtnDisabled$.next(true);
      this._QnSbnDataService.fbDisabledAndEnabled$.next(false);
      return;
    }
    
    if (route) {
      this.router.navigate([route]);
      
      // Calculate proper button states based on route position
      const routeIndex = this.routes.indexOf(route);
      
      // Previous button should be disabled only on the first page
      const isPrevDisabled = routeIndex === 0;
      
      // Next button should be disabled only on the last page
      const isNextDisabled = routeIndex === this.routes.length - 1;
      
     
      
      this.updateBtnState.emit({ isPrevState: isPrevDisabled, isNextState: isNextDisabled });
    }
    
    this.changeDetectorRef.detectChanges();
    this.asterixValidation();
  }

  public asterixValidation() {
    if(this.DueDateEnabled){
      if(!this.storedData || this._QnSbnDataService.isEmpty(this.storedData)){
        this.isDue_Rem = true;
      } else {
        const hasFeedbackDueDate = !this._QnSbnDataService.isEmpty(this.storedData.feedbackDueDate) 
          && this.storedData.feedbackDueDate.feedbackDueDate 
          && this.isValidDate(this.storedData.feedbackDueDate.feedbackDueDate);
        
        if(hasFeedbackDueDate){
          this.isDue_Rem = false;
        }else{
          this.isDue_Rem = true;
        }
      }
    }else{
      this.isDue_Rem = false;
    }
    
    if (!this.storedData || this._QnSbnDataService.isEmpty(this.storedData)) {
      return;
    }

    // Notification Documents
    if(this.DocumentEnabled) {
      if(
        ((this.storedData.notificationDoc && !this._QnSbnDataService.isEmpty(this.storedData.notificationDoc)) || (Array.isArray(this.storedData.notificationDocFileList) && this.storedData.notificationDocFileList.length > 0 ))
      ){
        this.isNotiDoc = false;
      }else{
        this.isNotiDoc = true;
      }
    } else {
      this.isNotiDoc = false;
    }
    
    // Recepients
    if(
      (!this._QnSbnDataService.isEmpty(this.storedData.recipientData) && Array.isArray(this.storedData.recipientData.recipientTable) && this.storedData.recipientData.recipientTable.length > 0 && this.storedData.recipientData.recipientTable.length <= this.contactLimitNumber && this.findDuplicates(this.storedData.recipientData.recipientTable).length <= 0  && this.findEmpties(this.storedData.recipientData.recipientTable).length <= 0)
    ){
      
      this.isRecepient = false;
    }else{
      this.isRecepient = true;
    }

    // Message And Attachments
    if(
      (!this._QnSbnDataService.isEmpty(this.storedData.messageAttachment) && this.storedData.messageAttachment.subjectName && this._AppUtils.extractContent(this.storedData.messageAttachment.messageAttachmentRTEText) !== "undefined" && this._AppUtils.extractContent(this.storedData.messageAttachment.messageAttachmentRTEText) !== "")
    ){
      this.isMess_Att = false;
    }else{
    
      this.isMess_Att = true;
    }

    // Daily Summary Report
    if(this.isEnableDailyReport){
      if(
        (!this._QnSbnDataService.isEmpty(this.storedData.dailyReportSendTo) && this.storedData.dailyReportSendTo !== "" && Array.isArray(this.storedData.dailyReportContent) && this.storedData.dailyReportContent.length > 0)
      ){
        this.isDailyReport = false;
      }else{
        this.isDailyReport = true;
      }
    }else{
      this.isDailyReport = false;
    }

    this.changeDetectorRef.detectChanges();
  }
  onConfirmationDialogClose() {
    this.confirmationDialogVisible = false;
  }

  onDialogClose(event: any) {
    this.visible = false;
  }

}

